import colors from '../tokens/colors';

export const pageHeaderGetolo = {
  color: {
    description: colors.PROFESSIONAL_LIGHT_BLUE,
    title: colors.PROFESSIONAL_BLUE,
  },
  typography: {
    description: 'body',
    title: 'h1',
  },
  textAlign: 'center',
};

export const pageHeaderDaDirekt = {
  color: {
    description: colors.PROFESSIONAL_BLUE,
    title: colors.PROFESSIONAL_BLUE,
  },
  typography: {
    description: 'body',
    title: 'h1',
  },
  textAlign: 'left',
};

export const pageHeaderDaKaufland = {
  color: {
    description: colors.DA_KAUFLAND_BLACK,
    title: colors.DA_KAUFLAND_BLACK,
  },
  typography: {
    description: 'p4',
    title: 'h2',
  },
  textAlign: 'left',
};

export const pageHeaderFressnapf = {
  color: {
    description: colors.COLOR_GREYISH_BLACK,
    title: colors.COLOR_FOREST_GREEN,
  },
  typography: {
    description: 'body',
    title: 'h1',
  },
  textAlign: 'center',
};
